var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.pullAppEn()}}},[_vm._v("Please use a browser to open")])
}
var staticRenderFns = []

export { render, staticRenderFns }